import { faBolt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { type DataTableBulkActionType, tableMessages } from 'src/registry/components/table';
import { Button } from 'src/registry/ui/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from 'src/registry/ui/DropdownMenu';
import { cn } from 'src/utils/shadcn';

type BulkActionsDropdownProps = {
    bulkActions: DataTableBulkActionType[];
    selectedIds: string[];
    setPendingAction: (action: DataTableBulkActionType | null) => void;
};

const BulkActionsDropdown = ({ bulkActions, selectedIds, setPendingAction }: BulkActionsDropdownProps) => {
    const { formatMessage } = useIntl();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline" size="xsIcon" disabled={selectedIds.length === 0}>
                    <FontAwesomeIcon className="text-primary-700" icon={faBolt} />
                    <div className="flex flex-col items-start sm:ml-1">
                        <span className="-mb-1 text-xs font-normal opacity-70">
                            {formatMessage(tableMessages.selectedCountEntries, {
                                count: selectedIds.length,
                            })}
                        </span>
                        <span className="text-sm">{formatMessage(tableMessages.applyMassAction)}</span>
                    </div>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-56">
                <DropdownMenuLabel>{formatMessage(tableMessages.applyMassActionOptions)}</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuGroup>
                    {bulkActions!.map((action) => {
                        return (
                            <DropdownMenuItem
                                key={action.label}
                                disabled={selectedIds.length === 0}
                                onSelect={(e) => {
                                    e.preventDefault();
                                    setPendingAction(action);
                                }}
                                className={cn(action.id === 'delete' && 'text-red-500')}
                            >
                                {action.icon && <FontAwesomeIcon icon={action.icon} className="mr-2" />}
                                {action.label}
                            </DropdownMenuItem>
                        );
                    })}
                </DropdownMenuGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default BulkActionsDropdown;
